import React, { useState } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import RewardsScreen from '@screens/Rewards/RewardsScreen';
import ListPromotionalCodesScreen from '@screens/PromotionalCodes/ListPromotionalCodesScreen';
import { canCurrentUser } from '@utils/Permissions';
import { Capability } from '@utils/Permissions/Capabilities';

/**
 * "Promociones": códigos promocionales y recompensas en UNA pantalla con dos
 * tabs (pedido de Irving, 2026-08-29). Antes eran dos renglones separados del
 * sidebar aunque son la misma decisión de negocio: cómo se premia al cliente.
 * Los códigos van primero por decisión suya — es lo que más se toca.
 *
 * ⚠️ **Las dos pantallas se montan TAL CUAL, sin tocarlas por dentro.** Cada una
 * trae su propio `p={4}` y su `Card`, así que aquí solo van los tabs: meterles
 * mano para "unificar el layout" sería reescribir dos pantallas que funcionan,
 * a cambio de nada que el usuario note.
 *
 * El `minHeight: 0` del contenedor no es decorativo — sin él, el hijo con
 * `height: 100%` empuja en vez de scrollear y el contenido se sale de la
 * pantalla (la misma lección del panel del POS y del tablero de cocina).
 */
const RewardsPromotionsScreen: React.FunctionComponent = () => {
    const [activeTab, setActiveTab] = useState(0);
    // Recompensas es un singleton global: el admin de sucursal solo ve los códigos (F6).
    const showRewards = canCurrentUser(Capability.PromoCodesManageGlobal);

    return (
        <Stack height="100%">
            <Tabs
                value={activeTab}
                onChange={(_, newValue) => setActiveTab(newValue)}
                variant="scrollable"
                sx={{ px: 2, pt: 1, flexShrink: 0 }}
            >
                <Tab label="Códigos promocionales" />
                {showRewards && <Tab label="Recompensas" />}
            </Tabs>
            <Box flex={1} minHeight={0}>
                {activeTab === 0 && <ListPromotionalCodesScreen />}
                {showRewards && activeTab === 1 && <RewardsScreen />}
            </Box>
        </Stack>
    );
};

export default RewardsPromotionsScreen;
